export default __webpack_public_path__ + "static/media/mobile-spacer.92b74a61.svg";